<template>
	<div
		:class="{
			'p-2': editFile,
		}"
		class="overflow-xh-ya mt-3 pl-2"
		style="max-height: calc(100vh - 200px); overflow: hidden"
	>
		<b-overlay :show="showSpinner || editSpinner">
			<b-row :class="editFile || editImage ? 'mt-0' : 'mt-3'">
				<b-col class="mr-3">
					<TextField
						text="Title"
						placeholder="Enter"
						modelKey="$model"
						:modelValue="validation.title"
						:error="validation.title.$error"
						:disabled="
							(progress > 0 && progress < 100) ||
							(uploadProgress > 0 && uploadProgress < 100)
						"
					/>
					<span
						v-if="!validation.title.maxLength && validation.title.required"
						class="required-font"
						style="left: 32px"
						>Should not exceed 124 characters</span
					>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col cols="12" class="assetbank-tags">
					<FormTags
						placeholder="e.g.,document"
						:isMandatory="false"
						class="mr-3"
						modelKey="tags"
						:modelValue="fileData"
						:disabled="
							(progress > 0 && progress < 100) ||
							(uploadProgress > 0 && uploadProgress < 100)
						"
					/>
				</b-col>
			</b-row>

			<b-row v-if="(addnewfile && !uploaded) || fileData.asset == ''">
				<b-col class="add-video-card mx-3">
					<b-card class="text-left upload-image-container" no-body>
						<div
							:class="{
								'error-upload-dot-cont': noVideo || errorFile,
							}"
							class="upload-dot-cont ucdSelDocFile position-relative py-3"
						>
							<section
								class="d-flex align-items-center justify-content-around w-100 mb-3"
							>
								<div
									class="d-flex align-items-start"
									v-if="
										fileData.assetType == '1' ||
										(fileData.asset == '' && !editFile && !editImage) ||
										(acceptedVideoTypes.includes(uploadfileExtension) &&
											fileData.assetType == '1') ||
										(acceptedVideoTypes.includes(uploadfileExtension) &&
											uploadlist)
									"
								>
									<img
										src="@/assets/asset-bank/listview/video-type.svg"
										alt=""
									/>
									<span class="ab-input-icon-heading text-left ml-2"
										>Video <br />
										<p class="ab-input-icon-subheading">
											MP4, MOV, WEBM <br />
											5 GB
										</p>
									</span>
								</div>
								<div
									class="d-flex align-items-start"
									v-if="
										(fileData.assetType == '3' && !editFile && editImage) ||
										(fileData.asset == '' && !editFile)
									"
								>
									<img src="@/assets/asset-bank/listview/img-type.svg" alt="" />
									<span class="ab-input-icon-heading text-left ml-2"
										>Images <br />
										<p class="ab-input-icon-subheading">
											PNG, JPG <br />
											20 MB
										</p>
									</span>
								</div>
								<div
									class="d-flex align-items-start"
									v-if="
										fileData.assetType == '2' ||
										fileData.assetType == '4' ||
										(fileData.asset == '' && !editFile && !editImage)
									"
								>
									<img src="@/assets/asset-bank/listview/doc-type.svg" alt="" />
									<span class="ab-input-icon-heading text-left ml-2"
										>Documents <br />
										<p class="ab-input-icon-subheading">
											PDF, PPT, ZIP<br />
											2 GB
										</p>
									</span>
								</div>
							</section>
							<h2
								class="black-txt cin-black-txt d-flex align-items-center flex-column"
							>
								<img
									class="mr-3 mb-3"
									src="@/assets/common/upload-cloud.svg"
									alt=""
								/>
								Drag & Drop to Upload
							</h2>

							<span class="d-flex align-items-center pointer">
								<span class="cin-blue-txt">or Browse</span></span
							>
							<input
								class="pointer"
								type="file"
								id="files"
								name="files"
								ref="fileInput"
								@change="handleFileUpload"
								:accept="fileTypes"
							/>
						</div>
					</b-card>
				</b-col>
			</b-row>

			<b-row
				v-else-if="(addnewfile && uploaded) || editImage || editFile"
				class="w-100 m-0"
			>
				<!-- use this col for edit  -->
				<b-col
					cols="12"
					class="view-image-container position-relative mt-3 pr-3"
					v-if="editImage"
				>
					<img
						class="w-100 h-100 rounded overflow-hidden"
						:src="fileData.asset"
						alt=""
					/>
					<section class="position-absolute ei-icons mr-2">
						<span class="position-relative">
							<img
								src="@/assets/asset-bank/listview/img-replace.svg"
								alt=""
								class=""
							/>
							<input
								@change="handleFileUpload"
								type="file"
								accept=" .png, .jpg,
					.jpeg"
								class="ml-2"
							/>
						</span>
						<img
							@click="deleteFileUpload"
							src="@/assets/asset-bank/listview/img-delete.svg"
							class="pointer ml-2"
							alt=""
						/>
					</section>
				</b-col>

				<b-col
					class="ab-uploaded-card w-100 mt-3"
					v-if="
						(!editImage && fileData.asset) ||
						(acceptedVideoTypes.includes(fileExtension) && fileData.asset) ||
						(editFile && fileData.asset)
					"
				>
					<b-card no-body class="d-flex w-100">
						<section class="d-flex align-items-center">
							<div
								class="ab-uploaded-file-heading d-flex align-items-center w-60"
							>
								<img
									v-if="fileExtension == 'pdf' || fileData.assetType == '4'"
									src="@/assets/asset-bank/listview/card-ppt-icon.svg"
									class="mr-2"
									alt=""
								/>
								<img
									v-else-if="
										fileExtension == 'ppt' ||
										fileExtension == 'pptx' ||
										fileData.assetType == '2'
									"
									src="@/assets/asset-bank/listview/card-pdf-icon.svg"
									class="mr-2"
									alt=""
								/>
								<img
									v-else-if="
										fileData.assetType == '1' ||
										acceptedVideoTypes.includes(fileExtension) ||
										fileExtension == 'mp4' ||
										(fileData.file &&fileData.file.type === 'video/mp4')
									"
									src="@/assets/asset-bank/grid-no-thumbnail.svg"
									class="mr-2"
									alt=""
								/>
								<img
                                    v-else-if="fileData.assetType == '8' || ['zip'].includes(fileExtension)"
                                    src="@/assets/asset-bank/grid-zip.svg"
                                    class="mr-2"
                                    alt=""
                                />
								<img
									v-else
									src="@/assets/asset-bank/default-image.svg"
									class="mr-2"
									alt=""
								/>
								{{ fileData.asset | cloudlink }}
							</div>
							<div
								class="ab-uploaded-file-subheading w-30 d-flex justify-content-end"
							>
								<span v-if="totalFiles === null">{{
									fileData.assetSize && fileData.assetSize.actualSize
								}}</span>

								<span class="ml-2 mr-5" v-if="timeRemaining || uploadTime">
									<!-- <img src="@/assets/course-structure/green-tick.svg" alt=""> -->
									{{ uploadTime ? uploadTime : timeRemaining }}Left</span
								>
								<span v-if="totalFiles && sizeInMB">{{
									sizeInMB ? sizeInMB : formatFileSize(uploadedFilesize)
								}}</span>
							</div>
							<div class="ml-3">
								<label  class="position-relative pointer" >
									<img
									class="pointer"
										v-if="
											((acceptedVideoTypes.includes(fileExtension) &&
												(progress === 0 || progress === 100) &&
												!editFile) ||
												(acceptedVideoTypes.includes(uploadfileExtension) &&
													(uploadProgress === 0 || uploadProgress === 100)) ||
												(!acceptedVideoTypes.includes(fileExtension) &&
													fileExtension !== '')) &&
											(progress === 0 || progress === 100) &&
											(!uploadProgress ||
												uploadProgress === 0 ||
												uploadProgress === 100) &&
											(fileExtension === '' ? !uploadlist && !editFile : true)
										"
										src="@/assets/common/replace.svg"
										alt=""
									/>
									<input
										@change="handleFileUpload"
										type="file"
										:accept="fileTypes"
										style="display: none"
									/>

								</label>
								<img
									class="ml-2 pointer"
									@click="deleteFileUpload"
									src="@/assets/common/delete.svg"
									alt=""
								/>
							</div>
						</section>

						<section
							class="mt-3"
							v-if="(!editFile && progress) || uploadProgress"
						>
							<b-progress
								v-if="progress"
								height="4px"
								:value="progress"
							></b-progress>
							<b-progress
								v-else-if="uploadProgress"
								height="4px"
								:value="uploadProgress"
							></b-progress>
						</section>
					</b-card>
				</b-col>
			</b-row>

			<b-row class="mt-2 w-100 ml-0 ab-file-card">
				<b-col class="w-100 p-0">
					<FileInput
						v-if="
							thumbnailPresent &&
							!uploadThumbnail &&
							(acceptedVideoTypes.includes(fileExtension) ||
								acceptedVideoTypes.includes(uploadfileExtension))
						"
						text="Upload Thumbnail"
						:fileTypes="acceptedImageTypes"
						@file-selected="handleThumbnail"
						:maxSizeInBytes="2 * 1024 * 1024 * 1024"
						:showAssetIcon="showAssetIcon"
					/>
					<div
						v-else-if="
							(uploadThumbnail ||
								fileData.assetThumbnail ||
								thumbnailData.previewKey) &&
							(acceptedVideoTypes.includes(fileExtension) ||
								acceptedVideoTypes.includes(uploadfileExtension))
						"
						:class="{
							'ab-thumbnail-image':
								fileData.assetThumbnail || thumbnailData.previewKey,
						}"
						class="rounded mx-3 mt-2"
					>
						<img
							v-if="thumbnailData.previewKey"
							class="w-100 h-100 overflow-hidden rounded"
							:src="thumbnailData.previewKey"
							alt=""
						/>
						<!-- <b-progress
							v-if="progress"
							height="4px"
							:value="progress"
						></b-progress> -->
						<img
							v-else-if="thumbnailData.previewKey || fileData.assetThumbnail"
							class="w-100 h-100 overflow-hidden rounded"
							:src="fileData.assetThumbnail"
							alt=""
						/>

						<section
							v-if="
								thumbnailData.previewKey ||
								(fileData.assetThumbnail && !uploadlist)
							"
							class="position-absolute ei-icons mr-2 mt-2 d-flex align-items-center"
						>
							<span
								class="position-relative"
								:class="{
									pointer:
										(progress === 0 && uploadProgress === undefined) ||
										(progress === 0 && uploadProgress === 0),
								}"
							>
								<ReplaceFile
									:uploadProgress="uploadProgress"
									:progress="progress"
									:replaceimg="replaceimg"
									:fileTypes="acceptedImageTypes"
									:maxSizeInBytes="2 * 1024 * 1024 * 1024"
									class="ml-2"
									@file-selected="selectFile"
								/>
							</span>
							<img
								:class="{
									'opacity-img ': progress > 0 || uploadProgress > 0,
									pointer:
										(progress === 0 && uploadProgress === undefined) ||
										(progress === 0 && uploadProgress === 0),
								}"
								@click="deleteThumbnailData()"
								src="@/assets/asset-bank/listview/img-delete.svg"
								class="ml-2"
								alt=""
							/>
						</section>
					</div>
				</b-col>
			</b-row>
		</b-overlay>
	</div>
</template>
<script>
import { getBucket } from "@/views/course-creation/api-client/courseInfoAPI";
import { postAsset } from "@/views/asset-bank/api-client/assets";
import fileUpload from "@/mixins/fileUpload";
import toast from "@/mixins/toast";
import { eventBus } from "@/utils/eventBus";
import { mapGetters } from "vuex";
export default {
	mixins: [fileUpload, toast],
	props: {
		fileData: {
			type: Object,
			required: true,
		},
		editSpinner: Boolean,
		editFile: Boolean,
		uploadId: String,
		editImage: Boolean,
		uploadProgress: Number,
		addnewfile: Boolean,
		thumbnailPresent: Boolean,
		validation: Object,
		uploadfileExtension: String,
		uploadedFilesize: Number,
		errorFile: Boolean,
		uploadlist: Boolean,
		uploadTime: String,
		selectedIndex: Number,
		noVideo: Boolean,
	},
	data() {
		return {
			sizeInMB: null,
			timeRemaining: "",
			startTime: null,
			totalFiles: null,
			fileIndex: null,
			replaceimg: true,
			showAssetIcon: true,
			uploadThumbnail: false,
			showSpinner: false,
			thumbnailData: {
				fileName: "",
				previewKey: "",
				sourceKey: "",
			},
			acceptedImageTypes: ".png, .jpg, .jpeg", // Set accepted image formats

			socket: null,
			fileExtension: "",
			progress: 0,
			isVideoPresent: false,
			uploadStatus: "",
			videoData: {
				previewKey: null,
			},
			uploadedFileData: {
				fileName: "",
				size: null,
				sourceKey: null,
				previewKey: null,
			},
			userData: {
				email: "",
				password: "",
			},
			fileTypes: ".pdf, .ppt, .png, .jpg, .jpeg, .mov, .mp4,.webm,.zip",
			acceptedVideoTypes: ["mp4", "mov", "webm"],
			value: 75,
			uploaded: false,
			assetType: null,
		};
	},

	watch: {
		fileData() {
			if (!this.uploadlist) {
				this.deleteThumbnail();
			}
		},
		activeProgress(newProgress) {
			if (newProgress > 0) {
				this.showSpinner = false;
			}
		},
	},
	computed: {
		...mapGetters("assetVUEX", {
			getfiles: "getUploadedFiles",
		}),
		activeProgress() {
			return this.progress > 0 ? this.progress : this.uploadProgress;
		},
	},
	mounted() {
		eventBus.$on("reset-method", this.resetMethod());
	},
	beforeDestroy() {
		eventBus.$off("reset-method", this.resetMethod());
	},
	methods: {
		handleThumbnail(fileData) {
			this.thumbnailData = fileData;
			this.uploadThumbnail = true;
			this.$emit("getThumbnail", this.thumbnailData.sourceKey);
			this.$emit("showThumbnail", this.thumbnailData);
		},
		selectFile(file) {
			this.thumbnailData.previewKey = file.previewKey;
			this.fileData.assetThumbnail = file.previewKey;
			this.$emit("getThumbnail", file.sourceKey);
			this.$emit("showThumbnail", this.thumbnailData);
			this.uploadThumbnail = true;
		},
		deleteFileUpload() {
			if (this.progress > 0 || this.uploadProgress > 0) {
				this.disconnectSocket();
				this.removeFiles();
			} else {
				this.thumbnailData = {
					fileName: "",
					previewKey: "",
					sourceKey: "",
				};
				this.fileData.asset = "";
				this.$emit("deleteFile");
				this.$emit("deleteImage");
				this.uploaded = false;
				this.uploadThumbnail = false;
				this.$emit("toogleNew", true);
			}
		},
		removeFiles() {
			this.$emit("showLoader");
			this.showSpinner = false;
			this.successToast("File Deleted Successfully");
			this.$emit("changeVal", "saveVideo");
			this.$emit("resetData");
			this.timeRemaining = "";
			this.progress = 0;
			this.uploaded = false;
			this.$store.commit("assetVUEX/REMOVE_COMPLETED_FILE", this.fileIndex);
			this.fileData.asset = "";
			this.deleteThumbnail();
		},
		formatTime(seconds) {
			const minutes = Math.floor(seconds / 60);
			const remainingSeconds = Math.floor(seconds % 60);

			if (minutes === 0) {
				return `${remainingSeconds} sec`;
			} else if (remainingSeconds === 0) {
				return `${minutes} min`;
			} else {
				return `${minutes} min ${remainingSeconds} sec`;
			}
		},
		disconnectSocket() {
			if (this.socket) {
				this.socket.disconnect();
				this.socket = null;
			}
		},

		resetMethod() {
			this.uploaded = false;

			// this.$emit("toogleNew", true);
		},
		getVideoLen() {
			return new Promise((resolve, reject) => {
				const video = document.createElement("video");
				const url = URL.createObjectURL(this.totalFiles);
				video.src = url;
				video.onloadedmetadata = () => {
					resolve(video.duration);
					URL.revokeObjectURL(url);
					video.remove();
				};
				video.onerror = (error) => {
					reject("Error loading video metadata: " + error.message);
					video.remove();
				};
			});
		},
		async processFiles() {
			let videoBucketPath;
			let thumbnailBucketPath;
			this.startTime = Date.now();
			this.showSpinner = true;
			this.fileData.asset = this.uploadedFileData.fileName;
			let fileDataCopy = Object.assign({}, this.fileData);
			try {
				if (this.assetType === 1) {
					this.uploadedFileData.videoLength = await this.getVideoLen();
				}
				this.isVideoPresent = true;
				this.uploadStatus = "Getting file, please wait...";
				let payload = {
					assetType: String(this.assetType),
				};
				const response = await getBucket(payload);
				if (response.status === 200) {
					if (this.assetType === 1) {
						this.$store.commit("assetVUEX/GET_FILE_DATA", this.fileData);
						this.$store.dispatch("assetVUEX/addUploadedFile", {
							fileName: this.uploadedFileData.fileName,
							videoLength: this.uploadedFileData.videoLength,
							previewKey: this.uploadedFileData.previewKey,
							fileSize: this.uploadedFileData.size,
							sourceKey: this.uploadedFileData.sourceKey,
							fileData: this.fileData,
							assetThumbnail: this.thumbnailData.previewKey,
						});
						this.fileIndex = this.getfiles.length - 1;
						videoBucketPath = await this.calculateHash(
							this.totalFiles,
							response.data.data,
							this.fileIndex,
							fileDataCopy,
							true
						);
						if (this.thumbnailData.sourceKey) {
							let payload = {
								assetType: "3",
							};
							const response = await getBucket(payload);
							if (response.status === 200) {
								thumbnailBucketPath = await this.calculateHash(
									this.thumbnailData.sourceKey,
									response.data.data,
									"",
									"",
									true
								);
							}
						}
						this.saveVideoAsset(videoBucketPath, thumbnailBucketPath);
					} else {
						this.calculateHash(this.totalFiles, response.data.data);
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		async saveVideoAsset(fileBucketPath, thumbnailBucketPath = null) {
			try {
				let payload = {
					title: this.fileData.title,
					assetType: String(this.assetType),
					tags: JSON.stringify(this.fileData.tags),
					assetLibrary: "true",
					asset: {
						uploadType: "1",
						path: fileBucketPath,
					},
				};
				if (this.assetType == 1) {
					payload.durationInSec = Math.floor(this.uploadedFileData.videoLength);
					if (this.thumbnailData.sourceKey) {
						payload.assetThumbnail = {
							uploadType: "1",
							path: thumbnailBucketPath,
						};
					}
				}
				const response = await postAsset(payload);
				if (response.status === 200) {
					setTimeout(() => {
						this.$nextTick(() => {
							this.successToast("Asset added successfully!");
						});
					}, 500);

					eventBus.$emit("hide-add-modal");
					if (this.acceptedVideoTypes.includes(this.fileExtension)) {
						eventBus.$emit("uploadComplete");
					}
					this.$emit("handle-get");
					this.$emit("closeModal");
					this.isVideoUploading = false;
					this.uploadStatus = "";
					return response.data.data;
				} else {
					this.showSpinner = false;
				}
			} catch (error) {
				console.log(error);
				this.showSpinner = false;
			}
		},

		deleteThumbnailData() {
			if (
				(this.progress === 0 && this.uploadProgress === undefined) ||
				(this.progress === 0 && this.uploadProgress === 0)
			) {
				this.uploadThumbnail = false;
				this.deleteThumbnail();
			}
		},
		deleteThumbnail() {
			this.thumbnailData = {
				fileName: "",
				previewKey: "",
				sourceKey: "",
			};
			this.$store.dispatch("assetVUEX/removeThumbnail", this.selectedIndex);
			this.fileData.assetThumbnail = "";
			this.$emit("removeThumbnail");
			this.uploadThumbnail = false;

			this.$emit("deleteFile");
		},
		formatFileSize(size) {
			if (isNaN(size) || size < 0) {
				return;
			}
			if (size < 1024) {
				return size + " B";
			} else if (size < 1024 * 1024) {
				return (size / 1024).toFixed(2) + " KB";
			} else {
				return (size / (1024 * 1024)).toFixed(2) + " MB";
			}
		},

		async handleFileUpload(event) {
			const files = event.target.files[0];
			this.sizeInMB = this.formatFileSize(files.size);
			if (!this.editFile) {
				this.fileExtension = files.name.split(".").pop().toLowerCase();
			}
			this.totalFiles = files;

			const MAX_VIDEO_SIZE = 5 * 1024 * 1024 * 1024;
			const MAX_OTHER_SIZE = 2 *1024 * 1024 * 1024;
			const allowedVideoFormats = ["mp4", "mov", "webm"];

			const fileExtension = files.name.split(".").pop().toLowerCase();
			const isVideo = allowedVideoFormats.includes(fileExtension);
			if (this.acceptedVideoTypes.includes(this.fileExtension)) {
				this.deleteThumbnail();
			}

			if (this.uploadlist && !isVideo) {
				this.errorToast("Only video files are allowed for upload.");
				event.target.value = "";
				return;
			}

			if (
				(isVideo && files.size > MAX_VIDEO_SIZE) ||
				(!isVideo && files.size > MAX_OTHER_SIZE)
			) {
	
				this.errorToast("File size exceeded");
				event.target.value = "";
				return;
			}

			this.uploaded = true;
			this.uploadedFileData = {
				files: files,
				fileName: files.name,
				size: files.size,
				sourceKey: files,
			};
			this.assetType = this.getAssetType(this.uploadedFileData.fileName);
			if (isVideo) {
				try {
					const duration = await this.getVideoLen();
					this.uploadedFileData.videoLength = duration;
				} catch (error) {
					this.errorToast("Failed to load video metadata.");
					return;
				}
			}
			this.$emit("fileUpload", this.uploadedFileData);
		},
		getAssetType(fileName) {
			const extension = fileName.split(".").pop().toLowerCase();
			switch (extension) {
				case "mp4":
				case "webm":
				case "mov":
					return 1;
				case "png":
				case "jpg":
				case "jpeg":
					return 3;
				case "ppt":
				case "pptx":
					return 2;
				case "pdf":
				case "txt":
					return 4;
				case "zip":
					return 8;
				default:
					return null;
			}
		},
	},
};
</script>

<style>
.opacity-img {
	opacity: 50%;
}
.ab-file-card .upload-image-container .card-body {
	padding: 1rem;
}

.assetbank-tabs .assetbank-tags ul {
	width: 100%;
}
.assetbank-tabs .assetbank-tags ul li {
	width: fit-content;
}
.ab-input-icon-heading {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-600);
	font-size: 16px;
	color: #788897;
}
.ab-input-icon-subheading {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-500);
	font-size: 12px;
	color: #5d5d5d;
	opacity: 0.5;
}
.ab-uploaded-file-heading {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-500);
	font-size: 14px;
	color: #000000;
}
.ab-uploaded-file-subheading {
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-400);
	font-size: 12px;
	color: rgba(93, 93, 93, 0.75);
}
.ab-uploaded-card .card {
	padding: 5px 10px;
	background: #ffffff;
	border: 1px solid #20639b !important;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	word-break: break-word;
}
.progress-bar {
	background-color: #20639b;
}
.input[type="file"] {
	width: 18%;
	height: 9%;
	display: block;
	/* opacity: 0; */
	position: absolute;
	top: -1px;
	background-color: red;
	left: 0px;
	/* padding: 2px; */
	cursor: pointer;
}
.ab-thumbnail-image {
	height: 350px;
}

.video-thumbnail-icon {
	left: 15%;
	top: 4px;
}
</style>
